import CaptionToggleButton from "@components/controls/CaptionToggleButton";
import t from "@ext/localization/locale/translate";
import { GlassToolbarButton, GlassToolbarIcon } from "@ui-kit/GlassToolbar";

interface ImageActionsProps {
	isGif?: boolean;
	hasSignature: boolean;
	caption: string | null;
	handleEdit: () => void;
	addSignature: () => void;
}

const ImageActions = (props: ImageActionsProps) => {
	const { isGif, hasSignature, caption, handleEdit, addSignature } = props;
	const editTooltip = t("edit2");
	const signatureTooltip = t("signature");

	return (
		<>
			{!isGif && (
				<GlassToolbarButton aria-label={editTooltip} onClick={handleEdit} tooltipText={editTooltip}>
					<GlassToolbarIcon icon="pencil" />
				</GlassToolbarButton>
			)}
			<CaptionToggleButton
				active={hasSignature}
				caption={caption}
				onToggle={addSignature}
				tooltipText={signatureTooltip}
			/>
		</>
	);
};

export default ImageActions;
